import PropTypes from "prop-types";

import StepContainer from "../../../ui/StepContainer";
import BottomBar from "../../../ui/BottomBar";
import { STEPS } from "../../../constants/stepsConstants";
import {
  getAnalysisType,
  getEvaluationType,
} from "../../../util/dataSelectors";
import {
  ANALYSIS_TYPES,
  NO_CURRENT_INTERSECTION,
} from "../../../constants/intxConstants";
import StepForm from "../../../ui/StepForm";
import { STEP_STORAGE_KEYS } from "../../../constants/storageConstants";
import { projectDataPropType } from "../../../util/propTypeHelper";
import InterchangeGlobalSafetyDataFields from "./InterchangeGlobalSafetyDataFields";
import AtGradeGlobalSafetyDataFields from "./AtGradeGlobalSafetyDataFields";
import Header from "../../../ui/Header";

export default function GlobalSafetyData({
  handleMainButtonClick,
  handleSecondaryButtonClick,
  projectData,
  saveFormData,
}) {
  const isInterchange =
    getAnalysisType(projectData) === ANALYSIS_TYPES.RAMP_TERMINAL_INTERSECTION;
  const {
    majorFacility: orientation,
    EWFacilityName,
    NSFacilityName,
  } = projectData[STEP_STORAGE_KEYS.PROJECT_INFORMATION];
  const evaluationType = getEvaluationType(projectData);
  const hasCurrentIntersection =
    projectData[STEP_STORAGE_KEYS.GLOBAL_INPUT_DATA].currentIntersection !==
    NO_CURRENT_INTERSECTION;
  const intersectionTypes = projectData[STEP_STORAGE_KEYS.INTERSECTIONS].map(
    ({ type }) => type
  );

  return (
    <StepContainer
      activeStep={STEPS.GLOBAL_SAFETY_DATA}
      evaluationType={evaluationType}
    >
      <StepForm
        onFormSubmit={handleMainButtonClick}
        projectData={projectData}
        saveFormData={saveFormData}
        storageKey={STEP_STORAGE_KEYS.GLOBAL_SAFETY_DATA}
      >
        {({ defaultValues, errors, formData, register, isDirty }) => {
          return (
            <>
              <Header
                subtitle="Data used for all safety calculations regardless of intersection types being analyzed"
                title="Global Safety Data"
              />
              <div style={{ marginTop: "40px" }}>
                {isInterchange ? (
                  <InterchangeGlobalSafetyDataFields
                    defaultValues={defaultValues}
                    errors={errors}
                    formData={formData}
                    hasCurrentIntersection={hasCurrentIntersection}
                    orientation={orientation}
                    EWFacilityName={EWFacilityName}
                    NSFacilityName={NSFacilityName}
                    register={register}
                  />
                ) : (
                  <AtGradeGlobalSafetyDataFields
                    defaultValues={defaultValues}
                    errors={errors}
                    formData={formData}
                    hasCurrentIntersection={hasCurrentIntersection}
                    intersectionTypes={intersectionTypes}
                    register={register}
                  />
                )}
              </div>
              <BottomBar
                handleSecondaryButtonClick={handleSecondaryButtonClick}
                projectData={projectData}
                withSubmitButton
                isFormDirty={isDirty}
              />
            </>
          );
        }}
      </StepForm>
    </StepContainer>
  );
}

GlobalSafetyData.propTypes = {
  handleMainButtonClick: PropTypes.func.isRequired,
  handleSecondaryButtonClick: PropTypes.func.isRequired,
  projectData: projectDataPropType.isRequired,
  saveFormData: PropTypes.func.isRequired,
};
